import React, { Component } from "react";

export const asyncComponent = (importComponent) => {
  class AsyncComponent extends Component {
    constructor(props) {
      super(props);

      this.state = {
        component: null,
      };
    }

    async componentDidMount() {
      const lazyRefreshKey = "lazy-refreshed-" + importComponent;
      try {
        const { default: component } = await importComponent();

        this.setState({
          component: component,
        });
        try {
          window.sessionStorage.setItem(lazyRefreshKey, "false");
        } catch (e) {
          console.log(
            "loaded chunky successfully, but no access to session storage",
            lazyRefreshKey,
            e,
          );
        }
      } catch (e) {
        console.error("Lazy", e);
        let hasRefreshed = false;
        try {
          hasRefreshed = JSON.parse(
            window.sessionStorage.getItem(lazyRefreshKey) || "false",
          );
        } catch (e) {
          console.log(
            "failed loading chunk, but no access to session storage",
            lazyRefreshKey,
            e,
          );
        }
        if (!hasRefreshed) {
          window.sessionStorage.setItem(lazyRefreshKey, "true");
          console.warn("Import error, trying a reload", e);
          window.location.reload();
        }
      }
    }

    render() {
      const C = this.state.component;

      return C ? <C {...this.props} /> : null;
    }
  }

  return AsyncComponent;
};
